import { render, staticRenderFns } from "./mainComment.vue?vue&type=template&id=e78a9096&scoped=true&"
import script from "./mainComment.vue?vue&type=script&lang=js&"
export * from "./mainComment.vue?vue&type=script&lang=js&"
import style0 from "./mainComment.vue?vue&type=style&index=0&id=e78a9096&lang=scss&scoped=true&"
import style1 from "./mainComment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78a9096",
  null
  
)

export default component.exports